module.exports = __webpack_public_path__ + "img/badge-legal-gas.65687a05.svg";